import React from 'react';
import ReactDOM from 'react-dom';
// Ported from projectpage/addToProjectFavorites.js.
import { AddToProjectFavoritesWidget } from '../common/addToProjectFavoritesWidget.js';

// isEligibleForFunding is set in proposal.jsp
// proposalId is set in ProposalControllerService.generatePageJSVariables
/* global isEligibleForFunding, userId, proposalId */

function renderAddToFavs(userId) {
    ReactDOM.render(
        React.createElement(AddToProjectFavoritesWidget, { favoritesStyle: 'project', projectId: parseInt(proposalId), isEligibleForFunding: isEligibleForFunding, userId: Number(userId) }),
        document.getElementById('add-to-project-favorites-heart-holder'),
    );

    ReactDOM.render(
        React.createElement(AddToProjectFavoritesWidget, { favoritesStyle: 'project', projectId: parseInt(proposalId), isEligibleForFunding: isEligibleForFunding, userId: Number(userId) }),
        document.getElementById('favorites-heart-holder-project-activity'),
    );
}

function setupAddToProjectFavorites() {
    if (!isEligibleForFunding) {
        return;
    }
    const userIdOrZero = (userId) || 0;
    renderAddToFavs(userIdOrZero);
}

export const main = () => {
    $(document).ready(function () {
        setupAddToProjectFavorites();
    });
};
